import React, { useRef } from 'react';
import { useForm, ValidationError } from '@formspree/react';

const Footer = () => {
  const [state, handleSubmit] = useForm('mandajnz');
  const formRef = useRef(null);

  const onSubmit = async (e) => {
    e.preventDefault();
    await handleSubmit(e);
    if (state.succeeded) formRef.current.reset();
  };

  return (
    <footer id="contact" className="bg-gradient-to-r from-blue-600 to-teal-500 text-white py-12">
      <div className="container mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-8">
        <div>
          <h2 className="text-2xl font-bold mb-4">Contact Us</h2>
          <p className="mb-2">
            Email:{' '}
            <a href="mailto:info@episurveillancekenya.com" className="hover:underline">
              info@episurveillancekenya.com
            </a>
          </p>
          <p className="mb-2">Phone: +254 716 144 715</p>
          <p className="mb-4">Kenya</p>
          <div className="flex space-x-4">
            <a
              href="https://x.com/KenyaEpi"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-80 flex items-center"
            >
              <svg
                className="w-6 h-6 mr-2"
                fill="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                aria-label="X logo"
              >
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
              </svg>
              <span>@KenyaEpi</span>
            </a>
            <a
              href="https://www.linkedin.com/in/episurveillance-kenya-696873289/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-80 flex items-center"
            >
              <svg
                className="w-6 h-6 mr-2"
                fill="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                aria-label="LinkedIn logo"
              >
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-1.337-.028-3.06-1.866-3.06-1.867 0-2.152 1.458-2.152 2.965v5.699h-3v-11h2.883v1.509h.041c.401-.76 1.385-1.562 2.849-1.562 3.047 0 3.609 2.006 3.609 4.614v6.439z" />
              </svg>
              <span>Episurveillance Kenya</span>
            </a>
          </div>
        </div>
        <div>
          <h2 className="text-2xl font-bold mb-4">Request a Demo</h2>
          <form ref={formRef} onSubmit={onSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              className="w-full p-2 mb-4 rounded text-gray-800"
              required
            />
            <ValidationError prefix="Name" field="name" errors={state.errors} />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              className="w-full p-2 mb-4 rounded text-gray-800"
              required
            />
            <ValidationError prefix="Email" field="email" errors={state.errors} />
            <textarea
              name="message"
              placeholder="Your Message"
              className="w-full p-2 mb-4 rounded text-gray-800"
              required
            ></textarea>
            <ValidationError prefix="Message" field="message" errors={state.errors} />
            <button
              type="submit"
              className="bg-white text-teal-500 px-4 py-2 rounded hover:bg-gray-100 transition-all"
              disabled={state.submitting}
            >
              Submit
            </button>
          </form>
          {state.succeeded && <p className="mt-4 text-green-300">Thank you!</p>}
        </div>
        <div>
          <ul className="mb-4 space-y-2">
            {['Services', 'Publications', 'Activities', 'Impact', 'Future', 'About', 'Contact'].map(
              (item, index) => (
                <li key={index}>
                  <a href={`#${item.toLowerCase()}`} className="hover:underline">
                    {item}
                  </a>
                </li>
              )
            )}
          </ul>
          <p>© 2025 Episurveillance Kenya. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;